<template>
  <div class="content-item">
    <h2 class="heading">Notes for the Designer</h2>
    <p class="text">Did you have anything specific you would like the designer to know?</p>
    <div class="form-group">
      <textarea v-model="notes" class="form-textarea"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step15',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      notes: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        notes: this.notes,
      });
    },
  },
};
</script>
